import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useAuth } from '../../../hooks/useAuth'
import * as mensajesService from '../../servicios/mensajesService'
import Mensajeria from './Mensajeria'

export const DetallePreguntas = ({
  tipo,
  idPublicacion: idPublicacionProp,
  idVendedor: idVendedorProp,
  vendedorNombre,
  idCompradorFiltro = null,
  idPublicacionEstado
}) => {
  const { loginDataContext: { idUsuario } = {} } = useAuth()
  const esVendedor = tipo === 'vendedor'
  const [mensajes, setMensajes] = useState([])
  const { idPublicacion: idPublicacionParam, idVendedor: idVendedorParam } = useParams()
  const idPublicacion = idPublicacionProp ?? parseInt(idPublicacionParam)
  const idVendedor = idVendedorProp ?? parseInt(idVendedorParam)

  const obtenerMensajes = async () => {
    let data = []
    try {
      if (esVendedor) {
        if (idCompradorFiltro) {
          data =
            (
              await mensajesService.buscarEnPublicacionPorComprador(
                idPublicacion,
                idCompradorFiltro
              )
            ).data || []
        } else {
          data = (await mensajesService.buscarPorPublicacion(idPublicacion)).data || []
        }
      } else {
        data =
          (await mensajesService.buscarEnPublicacionPorComprador(idPublicacion, idUsuario)).data ||
          []
      }
      const map = {}
      const roots = []

      data.forEach((msg) => {
        if (!map[msg.idMensaje]) {
          map[msg.idMensaje] = { ...msg }
        }
        if (!msg.idMensajePadre) {
          roots.push(map[msg.idMensaje])
        }
      })

      data.forEach((msg) => {
        if (msg.idMensajePadre && map[msg.idMensajePadre] && !map[msg.idMensajePadre].textoRta) {
          map[msg.idMensajePadre].textoRta = msg.texto
          map[msg.idMensajePadre].fechaEscritoRta = msg.fechaEscrito
          map[msg.idMensajePadre].idMensajeRta = msg.idMensaje
          if (msg.idsAdjuntos) map[msg.idMensajePadre].idsAdjuntosRta = msg.idsAdjuntos
        }
      })

      const actividad = (m) => new Date(m.fechaEscritoRta || m.fechaEscrito)
      roots.sort((a, b) => actividad(b) - actividad(a))
      setMensajes(roots)
    } catch {
      setMensajes([])
    }
  }

  useEffect(() => {
    obtenerMensajes()
  }, [idPublicacion, idVendedor, idUsuario, idCompradorFiltro])

  return (
    <div className="contenedor-msj">
      <Mensajeria
        idPublicacion={idPublicacion}
        mensajes={mensajes}
        setMensajes={setMensajes}
        vendedorNombre={vendedorNombre}
        esVendedor={esVendedor}
        idVendedor={idVendedor}
        idCompradorFiltro={idCompradorFiltro}
        idPublicacionEstado={idPublicacionEstado}
      />
    </div>
  )
}

DetallePreguntas.propTypes = {
  idPublicacion: PropTypes.number.isRequired,
  idVendedor: PropTypes.number.isRequired,
  tipo: PropTypes.string.isRequired,
  vendedorNombre: PropTypes.string,
  idCompradorFiltro: PropTypes.number,
  idPublicacionEstado: PropTypes.number
}

export default DetallePreguntas
